require('../../modules/es7.object.entries');
module.exports = require('../../modules/_core').Object.entries;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/fn/object/entries.js
 ** module id = 961
 ** module chunks = 0
 **/